import { useQuery } from '@tanstack/react-query';
import { axios } from '../../config/axios';
import { QUERY_KEYS } from '../../constants/queryKeys.const';
import { User } from '../../types/user.types';
import { Config } from '../../types/react-query.types';

export const useMessagedUsers = (config: Config = {}) => {
  return useQuery(
    [QUERY_KEYS.GET_MESSAGED_USERS],
    async (): Promise<User[]> => {
      return axios.get('users/messaged-users');
    },
    config,
  );
};
